import {CommonBuildConfigurationInput as BuildConfigurationInput} from '../commonConfiguration.types'

import {QuantityConfiguration} from './types'

export const buildQuantityConfiguration = ({
  options: {constraints}
}: BuildConfigurationInput): QuantityConfiguration => {
  return {
    quantity: constraints.quantity
  }
}
